import { Component, OnInit } from '@angular/core';
import { blogPosts } from '../../../../../data/blog-posts';
import { blogComments } from '../../../../../data/blog-comments';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService} from '../../../../service/api.service'
export type PagePostSidebarPosition = 'start' | 'end' | false;

export interface PagePostData {
    featuredImage: boolean;
    sidebarPosition: PagePostSidebarPosition;
}

@Component({
    selector: 'app-page-post',
    templateUrl: './page-post.component.html',
    styleUrls: ['./page-post.component.scss'],
})
export class PagePostComponent implements OnInit {
    posts = blogPosts;
    comments = blogComments;

    featuredImage = true;

    sidebarPosition: PagePostSidebarPosition = 'start';

    get hasImage(): boolean {
        return this.featuredImage;
    }

    constructor(
        private route: ActivatedRoute,
        private service : ApiService,
        private router : Router
    ) { }
    data:any;
    ngOnInit(): void {
        this.loadData();
        this.route.data.subscribe((data: PagePostData) => {
            this.featuredImage = data.featuredImage;
            this.sidebarPosition = data.sidebarPosition;
        });
    }

    loadData(){
        if(this.route.snapshot.paramMap.get("slug")){
            this.service.getLatestNewsById(this.route.snapshot.paramMap.get("slug")).subscribe((res:any) => {
                console.log(res)
                this.data = res;
            }, (err:any) => {
                if(err.status === 404){
                    console.log('404')
                    this.router.navigate(["**"])
                }
            })
        }
    }
}
